import React from 'react';
import { CheckCircleOutlined, UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons';
import { UtilizationInventoryCard } from './UtilizationInventoryCard';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import RamSvg from '../../../assets/icons/ram.svg?raw';
import {
    calculatePercentage,
    formatPercent,
    oversizedUndersizedState,
} from '../../SummaryWrapper/inventorySummaryHelpers';
import { formatCount, formatDecimal } from '../../../pages/Discovery/helpers';

export const RAMUtilizationCard = ({
    optimizedByRAM,
    totalInventory,
    totalRAM,
    ramReductionOpportunities,
    undersizedRAM,
    primaryTrend,
    oversizedTrend,
    undersizedTrend,
    isExpanded,
    onFilterClick,
    ...props
}) => {
    return (
        <UtilizationInventoryCard
            title="RAM Utilization"
            subLabelIcon={<CheckCircleOutlined />}
            subLabelIconClass="success-icon"
            subLabel="Optimized VMs"
            primaryValue={formatCount(optimizedByRAM)}
            primaryPercent={formatPercent(calculatePercentage(optimizedByRAM, totalInventory))}
            primaryTrend={primaryTrend}
            description={'Instances meeting\nutilization thresholds'}
            rows={[
                {
                    variant: 'ready',
                    label: 'Total RAM',
                    count: formatDecimal(totalRAM?.value ?? 0),
                    countSuffix: totalRAM?.unit ?? 'GiB',
                    icon: <CustomSVG svg={RamSvg} />,
                },
                {
                    variant: 'ready',
                    label: 'Oversized VMs',
                    count: formatCount(ramReductionOpportunities),
                    percent: formatPercent(calculatePercentage(ramReductionOpportunities, totalInventory)),
                    percentTrend: oversizedTrend,
                    oversizedUndersizedState: oversizedUndersizedState(oversizedTrend),
                    iconVariant: 'notReady',
                    icon: <UpCircleOutlined />,
                    onClick: onFilterClick ? () => onFilterClick(['oversized_ram']) : undefined,
                },
                {
                    variant: 'notReady',
                    label: 'Undersized VMs',
                    count: formatCount(undersizedRAM),
                    percent: formatPercent(calculatePercentage(undersizedRAM, totalInventory)),
                    percentTrend: undersizedTrend,
                    oversizedUndersizedState: oversizedUndersizedState(undersizedTrend),
                    icon: <DownCircleOutlined />,
                    onClick: onFilterClick ? () => onFilterClick(['undersized_ram']) : undefined,
                },
            ]}
            isExpanded={isExpanded}
            {...props}
        />
    );
};
